import {get, set, omit} from 'lodash';

export function migrateSkills(profile) {
  const skills = get(profile, 'viewState.progress.applicant.application.Skills');
  if (skills) {
    const newSkills = omit(skills, [
      'Types of Firms or Organizations worked for',
      'Industry Segment',
      'Positions or Types of Work',
      'Special Areas of Knowledge',
      'Management Systems',
      'Carriers Worked With'
    ]);
    set(profile, 'viewState.progress.applicant.application.Skills', newSkills);
  }
  return profile;
}



// WEBPACK FOOTER //
// ./shared/redux/helpers/applicants.js